import { INutrientItem } from "@/types/Nutrition.types";

export const GRAM_UNIT = "g" as const;

/**
 * Default nutrients for Pet Foods
 * These are the standard guaranteed analysis nutrients that should be displayed
 * when no nutrients are loaded from the API.
 * `id` values with the `default-` prefix are client-only: they are not sent to
 * `saveNutrient` and are replaced in state by the id returned in the response after save.
 */
export const PET_FOOD_DEFAULT_NUTRIENTS: INutrientItem[] = [
    {
        id: "default-crude-protein-min",
        nutrient: "Crude Protein (min)",
        unitOfMeasure: "%",
        valueOnLabCoA: "",
        valueToAppearOnLabel: "",
        nutritionUnitOfMeasure: "%"
    },
    {
        id: "default-crude-fat-min",
        nutrient: "Crude Fat (min)",
        unitOfMeasure: "%",
        valueOnLabCoA: "",
        valueToAppearOnLabel: "",
        nutritionUnitOfMeasure: "%"
    },
    {
        id: "default-crude-fiber-max",
        nutrient: "Crude Fiber (max)",
        unitOfMeasure: "%",
        valueOnLabCoA: "",
        valueToAppearOnLabel: "",
        nutritionUnitOfMeasure: "%"
    },
    {
        id: "default-moisture-max",
        nutrient: "Moisture (max)",
        unitOfMeasure: "%",
        valueOnLabCoA: "",
        valueToAppearOnLabel: "",
        nutritionUnitOfMeasure: "%"
    }
];
